import { SORT_OPTIONS } from '@/modules/pmt/constants';
import { DEFAULT_QUERY_LIMIT } from '@/modules/pmt/constants';
import { useShipmentFiltersContext, useShipmentsOverviewContext } from '@/modules/pmt/context';
import { LoadMore } from '../LoadMore';
import { buildShipmentsTemplates } from './utils';

const Shipments = () => {
  const { filterConfig, updateCurrentLimit } = useShipmentFiltersContext();
  const { shipments, hasMoreShipments } = useShipmentsOverviewContext();

  const onLoadMore = () => {
    updateCurrentLimit(filterConfig.currentLimit + DEFAULT_QUERY_LIMIT);
  };

  const shipmentsBySeparators = buildShipmentsTemplates(shipments, filterConfig.currentSort);

  const renderShipments = () => {
    if (filterConfig.currentSort === SORT_OPTIONS.LATEST_ADDED) {
      return [...shipmentsBySeparators.recentlyAdded, ...shipmentsBySeparators.past];
    }

    if (filterConfig.currentSort === SORT_OPTIONS.DELIVERY_DATE) {
      return [
        ...shipmentsBySeparators.today,
        ...shipmentsBySeparators.tomorrow,
        ...shipmentsBySeparators.thisWeek,
        ...shipmentsBySeparators.soon,
        ...shipmentsBySeparators.pendingDeliveryDate,
      ];
    }

    return shipmentsBySeparators.all;
  };

  return (
    <>
      {renderShipments()}
      {hasMoreShipments && <LoadMore key='load-more-shipments' onClick={onLoadMore} />}
    </>
  );
};

export { Shipments };
